<script lang="ts">
    import {onMount} from "svelte";
    import ImageView from "../../../../../component/common/Image/ImageView.svelte";
    import {BinaryUtil} from "../../../../../lib/BinaryUtil";
    import {BinaryTable} from "../../../../../lib/Table/BinaryTable";
    import DynamicAnkerView from "../../../../../component/common/Link/DynamicAnkerView.svelte";

    export let binary;
    export let jumpUrl = null;

    $: thumbnailUrl = (() => {
        if (binary == null) {
            return null;
        }

        const thumbnailUrl = BinaryUtil.createThumbnailUrl(binary);
        return thumbnailUrl;
    })();

    onMount(() => {
    });


</script>

<div class="binary-icon-view" data-thumbnail-url={thumbnailUrl}>
    {#if binary.type === BinaryTable.Type.Application}
        <DynamicAnkerView href={jumpUrl}>
            <ImageView src={thumbnailUrl}/>
        </DynamicAnkerView>

    {:else if binary.type === BinaryTable.Type.UnityAssetBundle}
        <div class="text">
            Unity<br/>Asset Bundle
        </div>
    {/if}


</div>
<style lang="scss">
    .binary-icon-view {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        > :global(a) {
            width: 100%;
            height: 100%;
        }

        .text {
            display: flex;
            align-items: center;
            justify-items: center;
            font-size: 0.75em;
            opacity: 0.75;

            text-align: center;
            border-style: solid;
            border-width: 1px;
            padding: 4px;
            border-radius: 4px;
        }
    }
</style>